import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import Backend from 'i18next-xhr-backend'
// not like to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init
import de from './de/translation.json'
import en from './en/translation.json'

import 'dayjs/locale/de'
import 'dayjs/locale/en'
import dayjs from 'dayjs'

dayjs.extend(require('dayjs/plugin/localizedFormat'))

const resources = {
  en: {
    translation: en
  },
  de: {
    translation: de
  }
}

i18n
  // load translation using xhr -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-xhr-backend
  .use(Backend)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    debug: false,
    react: {
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p', 'b']
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
      format: function (value, rawFormat, lng) {
        const [format, ...additionalValues] = rawFormat.split(',').map((v) => v.trim())
        switch (format) {
          case 'format_price':
            return Intl.NumberFormat(lng, {
              style: 'currency',
              currency: additionalValues[0]
            }).format(value)
          default:
            return value
        }
      }
    }
  })

export default i18n
